import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IInstagramStory,
  IInstagramStoryInitialState,
} from "./instagramStoryModel";
import {
  ActiveInactiveInstagramStory,
  createInstagramStory,
  deleteInstagramStory,
  getAllActiveInstagramStories,
  getAllInstagramStories,
  getInstagramStoryByID,
  InstagramStoryImageUpload,
  updateInstagramStory,
} from "./services/instagramStory.services";

const initialState: IInstagramStoryInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  InstagramStoryList: [],
  InstagramStoryID: null,
  InstagramStoryDetail: {
    Title: "",
    URL: "",
    IsActive: 1,
  },
};

const instagramStorySlice = createSlice({
  name: "instagramStory",
  initialState,
  reducers: {
    clearInstagramStoryDetails: (state) => {
      state.InstagramStoryDetail = initialState.InstagramStoryDetail;
    },
    setInstagramStoryID: (state, action) => {
      state.InstagramStoryID = action.payload;
    },
    clearInstagramStoryID: (state) => {
      state.InstagramStoryID = initialState.InstagramStoryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllInstagramStories.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllInstagramStories.fulfilled,
      (state, action: PayloadAction<IInstagramStory[]>) => {
        state.loading = false;
        state.InstagramStoryList = action.payload || [];
      }
    );
    builder.addCase(getAllInstagramStories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.InstagramStoryList = [];
    });
    builder.addCase(createInstagramStory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createInstagramStory.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createInstagramStory.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateInstagramStory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateInstagramStory.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateInstagramStory.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteInstagramStory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteInstagramStory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteInstagramStory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getInstagramStoryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getInstagramStoryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.InstagramStoryDetail = action.payload;
    });
    builder.addCase(getInstagramStoryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.InstagramStoryDetail = initialState.InstagramStoryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveInstagramStories.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveInstagramStories.fulfilled,
      (state, action: PayloadAction<IInstagramStory[]>) => {
        state.loading = false;
        state.InstagramStoryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveInstagramStories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.InstagramStoryList = [];
    });
    builder.addCase(ActiveInactiveInstagramStory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveInstagramStory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveInstagramStory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(InstagramStoryImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(InstagramStoryImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(InstagramStoryImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearInstagramStoryDetails,
  clearInstagramStoryID,
  setInstagramStoryID,
} = instagramStorySlice.actions;
export default instagramStorySlice.reducer;
